import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url';
import styled from 'styled-components';

export function clearPolygon(
  i: number,
  polygons: google.maps.LatLngLiteral[][],
  updatePolygons: (polygon: google.maps.LatLngLiteral[][]) => void,
): void {
  updatePolygons(polygons.filter((_, index) => index !== i));
}

export const Right = styled.div`
  position: absolute;
  right: 4px;
  top: 4px;
  max-height: 200px;
  z-index: 999;
`;

export const Left = styled.div`
  position: absolute;
  left: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  top: 4px;
  max-height: 200px;
  z-index: 999;
`;

export const RelativeContainer = styled.div`
  width: 0;
  position: relative;
`;

// The `drawing` library was removed from the Maps JS API in v3.65; polygon
// drawing is now handled manually (see Map/shared/PolygonDraw). No other
// optional libraries are used, so none are loaded.
export const libraries: Libraries = [];
